import { ApplicationIntent } from '@borg/types';

class ApplicationIntentsService {
  create = (data: ApplicationIntent) =>
    serviceHttpPostFactory<ApplicationIntent>('/application-intents', data);
  update = (id: number, data: Partial<ApplicationIntent>) =>
    serviceHttpPatchFactory<ApplicationIntent>(`/application-intents/${id}`, data);
}

export const applicationIntentsService = new ApplicationIntentsService();
